import { LocalStorageService } from './../../../../core/services/local-storage.service';
import { PageService } from './../../../../core/services/page/page.service';
import { Component } from '@angular/core';
import { Successpage, serverError } from './../../../../core/models/messages';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-pages',
  templateUrl: './pages.component.html',
  styleUrls: ['./pages.component.css'],
})
export class PagesComponent {
  idActor: any;
  company_id: any;
  company_idd: any;
  subPageIds: number[] = [];
  idActorclient: any;
  /* array */
  listPages: any;
  /* unsubscription */
  private unsubscribeAll: Subject<void> = new Subject();
  constructor(
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private pageActorService: PageService,
    private localStorageService: LocalStorageService
  ) {}
  ngOnInit() {
    this.idActor = this.localStorageService.getData('roleUseresn');
    this.idActorclient = this.localStorageService.getData('roleUserclient');
    (this.company_id = this.localStorageService.getData('clientConnected')),
      (this.company_idd = this.localStorageService.getData('userConnected')),
      console.log('idclientclient', this.idActorclient);
    this.getListPagesActor();
  }

  /* get list  pages by actor */
  getListPagesActor() {
    this.spinner.show();
    if (this.company_idd == '2') {
      this.pageActorService
        .listPageActor(this.idActor)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {
            console.log('reponse', res);
            if (res.status == 200) {
              this.spinner.hide();
              this.listPages = res.data;
              console.log('pageeeeeeeee', this.listPages);
            }
          },
          error: () => {
            this.spinner.hide();
            this.toastr.error(serverError);
          },
        });
    } else {
      this.pageActorService
        .listPageActorclient()
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {
            console.log('reponse', res);
            if (res.status == 200) {
              this.spinner.hide();
              this.listPages = res.data;
              console.log('pageeeeeeeee', this.listPages);
            }
          },
          error: () => {
            this.spinner.hide();
            this.toastr.error(serverError);
          },
        });
    }
  }
  changeSelection(subPage: any) {
    if (!this.subPageIds.includes(subPage.id)) {
      this.subPageIds.push(subPage.id);
      console.log('subcategory', this.subPageIds);
    } else {
      const indexToRemove = this.subPageIds.indexOf(subPage.id);
      if (indexToRemove !== -1) {
        this.subPageIds.splice(indexToRemove, 1);
        console.log('subcategorynnn', this.subPageIds);
      }
    }
  }
  changeSubPageState() {
    this.spinner.show();
    if (this.company_idd == '2') {
      let data = {
        company_id: this.localStorageService.getData('clientConnected'),
        // company_id:this.idActor,
        sub_page_id: this.subPageIds,
      };
      console.log('data', data);
      this.pageActorService
        .changeSubPageState(data)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {
            if (res.status == 200) {
              this.spinner.hide();
              // this.listPages = res.data
              this.toastr.success(Successpage);
            }
          },
          error: () => {
            this.spinner.hide();
            this.toastr.error(serverError);
          },
        });
    } else {
      let data = {
        company_id: this.localStorageService.getData('clientConnected'),
        // company_id:this.idActor,
        sub_page_id: this.subPageIds,
      };
      console.log('data', data);
      this.pageActorService
        .changeSubPageState(data)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {
            if (res.status == 200) {
              this.spinner.hide();
              // this.listPages = res.data
              this.toastr.success(Successpage);
            }
          },
          error: () => {
            this.spinner.hide();
            this.toastr.error(serverError);
          },
        });
    }
  }

  /* unsubscribe from api */
  ngOnDestroy() {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }
}
